//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NavigationItem from '~sdp-components/Navigation/NavigationItem'

export default {
  components: {
    NavigationItem,
  },
  data() {
    return {
      goalsExpanded: false,
      guardrailsExpanded: false,
      implementationsExpanded: false,
    }
  },
  created() {
    // if we are in a goals route show goals; guardrail -> guardrail
    const name = this.$route.path
    if (name) {
      const split = name.split('/')
      if (split.length > 1) {
        if (split[1].includes('guardrail')) {
          this.guardrailsExpanded = true
        } else if (split[1].includes('goal')) {
          this.goalsExpanded = true
        } else if (split[1].includes('implementationFrameworks')) {
          this.implementationsExpanded = true
        }
      }
    }
  },
  methods: {
    handleGoalsExpanded() {
      this.goalsExpanded = !this.goalsExpanded
      this.guardrailsExpanded = false
      this.implementationsExpanded = false
    },
    handleGuardrailsExpanded() {
      this.guardrailsExpanded = !this.guardrailsExpanded
      this.goalsExpanded = false
      this.implementationsExpanded = false
    },
    handleImplementationsExpanded() {
      this.implementationsExpanded = !this.implementationsExpanded
      this.goalsExpanded = false
      this.guardrailsExpanded = false
    },
  },
}
